import {default as enUS} from './enUS.json';
import {default as deDE} from './deDE.json';

export default {
    [enUS.locale]: enUS,
    [deDE.locale]: deDE,
};
